import React from 'react'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Box, Grid, Paper } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'

import Spinner from '../Spinner'
import NotFound from '../NotFound'
import Beta from '../widgets/Beta'
import Thumbnail from '../widgets/Thumbnail'
import MultiSelectDropDown from './MultiSelectDropDown'
import { CONTENT_PERFORMANCE } from '../../constants/module_info'

import './AudienceAcquisitionComponent.scss'
import { theme } from '../../classes/Themes'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { AUDIENCE_ACQUISITION_START_DATE, AUDIENCE_LIFT_MODULE, GENRE, NA, NETWORK_AUDIENCE_LIFT, NEW_TO_NETWORK, PREMIERE_DATE } from '../../constants/commons'
import DateHelpers from '../../classes/DateHelpers'
import Profile from '../../classes/profile'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

class AcquisitionPremiereComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    profile: Profile.PropTypes,
    location: PropTypes.object,
    homepage: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    audienceAcquisition: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      audienceAcquisition: {
        isFetching: false,
        error: null,
        selectedNetwork: ''
      },
      page: 0
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(AUDIENCE_LIFT_MODULE, this.props.location, this.props.profile)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.audienceAcquisition !== this.props.audienceAcquisition) {
      this.handleChangePage(0)
    }

    if (prevProps.audienceAcquisition != this.props.audienceAcquisition && this.props.audienceAcquisition.details) {
      this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network && this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
    }
  }

  setSelectedNetwork = (network) => {
    this.setState({ selectedNetwork: network })
  }

  handleChangePage = page => {
    this.setState({ page: page})
  }

  render () {
    if (this.props.homepage.isFetching) {
      return (<Spinner />)
    }

    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.network_entities && this.props.homepage.details.network_entities.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} lg={12} md={12} sm={12} id='contentPerformance'
          style={{transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })}}>
          <Paper className="cardBase p-b-0">
            <Grid container direction="column">
              <Grid item className='cardPadding'>
                <span className="cardTitle">Content Performance<Beta color='#A9A9A9'/></span>
                <OverlayTrigger overlay={<Tooltip id="tooltip">{CONTENT_PERFORMANCE}</Tooltip>} placement="right">
                  <img src="/static/images/info.png" alt="info" className="cardInfo" />
                </OverlayTrigger>
              </Grid>
              <Grid item className="cardSubTitle">Audience acquisition based on premiere audience (contribution to {this.state.selectedNetwork} from launch week engagement)</Grid>
              { ((this.props.audienceAcquisition && this.props.audienceAcquisition.isFetching) || (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.content_performance.length === 0)) &&
                <div className='loadingProgress'>
                  <CircularProgress />
                </div>
              }
              { (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.content_performance.length > 0) &&
                <ContentPerformance
                  classes={this.props.classes}
                  page={this.state.page}
                  handleChangePage={this.handleChangePage}
                  audienceAcquisition={this.props.audienceAcquisition}
                  shortcut={this.props.shortcut}
                />
              }
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export class ContentPerformance extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    audienceAcquisition: PropTypes.object,
    details: PropTypes.array,
    page: PropTypes.number.isRequired,
    handleChangePage: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      rowsPerPage: 10,
      searchText: '',
      order: 'desc',
      orderBy: PREMIERE_DATE,
      showBenchmark: false,
      selectedGenres: [],
      showShortcutDataLimitText: false
    }
    this.searchRef = React.createRef()
  }

  componentDidMount () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  componentDidUpdate () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  onSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value })
    if (e.target.value.length > 0) {
      this.props.handleChangePage(0)
    }
    this.searchRef.current.focus()
    this.setState({ isOpen: false})
  }

  renderPieChart = date => {
    if ((new Date(date).getTime() > new Date(AUDIENCE_ACQUISITION_START_DATE).getTime())) {
      return true
    } else {
      return false
    }
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    })
    this.props.handleChangePage(0)
    this.setState({ isOpen: false})
  }

  createData = (topic_id, thumbnail, entity_override_image, name, premiere_date, genre, new_to_network, network_audience_lift) => {
    return { topic_id, thumbnail, entity_override_image, name, premiere_date, genre, new_to_network, network_audience_lift }
  }

  getDate = (entity) => {
    const date = entity.entity_localization_override && entity.entity_localization_override.length > 0 && entity.entity_localization_override[0].active_date ? entity.entity_localization_override[0].active_date : entity.premiere_date
    return date
  }

  formatDate = (date) => {
    if (date) {
      const premiereDate = moment(DateHelpers.getDateWithoutTime(date))
      if (DateHelpers.isYearEndDate(premiereDate)) {
        return premiereDate.format('YYYY')
      }
      return premiereDate.format('MM.DD.YYYY')
    }
    return date
  }

  handleGenres = (genres) => {
    if (genres.indexOf('All') > -1) {
      this.setState({ selectedGenres: [], selectedModule: GENRE, isOpen: true })
    } else {
      this.setState({ selectedGenres: genres, selectedModule: GENRE, isOpen: true })
    }
    this.props.handleChangePage(0)
  }

  handleChangePage = (event, newPage) => {
    this.props.handleChangePage(newPage)
    this.setState({ isOpen: false})
  }

  paginationLabel = (from, to, count, totalCount) => {
    if (!this.props.shortcut || (this.props.shortcut && totalCount <= 20)) {
      return `${from}-${to} of ${count}`
    }

    if (to === count && count !== 0 && !this.state.showShortcutDataLimitText) {
      this.setState({showShortcutDataLimitText: true})
    }

    if ((to !== count || count === 0) && this.state.showShortcutDataLimitText) {
      this.setState({showShortcutDataLimitText: false})
    }

    return `${from}-${to} of ${count}`
  }

  render () {
    const rowData = this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.content_performance
    const totalCount = this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_lift_count
    let rows = rowData ? rowData.filter(cp => new Date(cp.premiere_date) <= new Date()) : []
    rows = this.state.searchText.length > 0 ? rows.filter(e => e.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1 || (e.display_name && e.display_name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1)) : rows
    rows = rows.map(e => this.createData(e.topic_id, e.thumbnail, e.entity_override_image, e.display_name || e.name, this.getDate(e), e.genre, this.renderPieChart(e.premiere_date) ? e.data.new_to_network : NA, this.renderPieChart(e.premiere_date) ? e.data.network_audience_lift : NA))

    let uniqueRows = rows.reduce((unique, o) => {
      if (!unique.some(obj => obj.name === o.name)) {
        unique.push(o)
      }
      return unique
    }, [])

    let genreList = []
    uniqueRows.length > 0 && uniqueRows.map(e => {
      if (e.genre && e.genre.length === 1) {
        genreList.push(e.genre[0])
      } else if (e.genre && e.genre.length > 1) {
        e.genre.map(g => genreList.push(g))
      }
    })
    let genres = genreList.reduce((unique, o) => {
      if (!unique.some(obj => obj === o)) {
        unique.push(o)
      }
      return unique
    }, [])
    genres = genres.sort((a, b) => (a < b) ? -1 : (a > b) ? 1 : 0)

    uniqueRows = uniqueRows && this.state.selectedGenres && this.state.selectedGenres.length > 0 ? this.state.selectedGenres.flatMap(genre => uniqueRows.filter(t => t.genre && t.genre[0] === genre)) : uniqueRows

    let resultRows = []
    if (this.state.orderBy === NEW_TO_NETWORK || this.state.orderBy === NETWORK_AUDIENCE_LIFT) {
      const rowWithoutNA = uniqueRows.filter(u => u.new_to_network !== NA && u.network_audience_lift !== NA)
      const rowWithNA = uniqueRows.filter(u => u.new_to_network === NA && u.network_audience_lift === NA)
      resultRows = this.sortData(rowWithoutNA, this.getComparator(this.state.order, this.state.orderBy)).concat(rowWithNA)
    } else {
      resultRows = this.sortData(uniqueRows, this.getComparator(this.state.order, this.state.orderBy))
    }

    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    return (
      <>
        <TableContainer className="mt-2 acquisitionTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell>
                  <input type="text" name="name" placeholder="Name" className="nameInput" autoComplete="off" value={this.state.searchText} onChange={this.onSearchTextChange} ref={this.searchRef}/>
                </StyledTableCell>
                <StyledTableCell sortDirection={this.state.orderBy === PREMIERE_DATE ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === PREMIERE_DATE}
                    direction={this.state.orderBy === PREMIERE_DATE ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(PREMIERE_DATE)}
                  >
                    <Box className="flexCenter">Premiere Date</Box>
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <MultiSelectDropDown
                    module={GENRE}
                    data={genres}
                    selectedValues={this.state.selectedGenres}
                    handleSelect={this.handleGenres}
                    isOpen={this.state.selectedModule === GENRE ? this.state.isOpen : false}
                  />
                </StyledTableCell>
                <StyledTableCell sortDirection={this.state.orderBy === NEW_TO_NETWORK ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === NEW_TO_NETWORK}
                    direction={this.state.orderBy === NEW_TO_NETWORK ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(NEW_TO_NETWORK)}
                    >
                    New to Network
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="right" sortDirection={this.state.orderBy === NETWORK_AUDIENCE_LIFT ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === NETWORK_AUDIENCE_LIFT}
                    direction={this.state.orderBy === NETWORK_AUDIENCE_LIFT ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(NETWORK_AUDIENCE_LIFT)}
                    >
                    <Box className="headerLabelWrap">Network Audience Lift</Box>
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { this.state.showBenchmark &&
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Netflix average benchmark</TableCell>
                  <TableCell>--</TableCell>
                  <TableCell>--</TableCell>
                  <TableCell>
                    <Box className="flexCenter"><div className="pie mr-1" style={{backgroundImage: 'conic-gradient(#808184 45.5%, #E5E5E5 1.5%, #E5E5E5)'}}></div>45.5%</Box>
                  </TableCell>
                  <TableCell align="right">
                    <Box className="flexCenterStart"><div className="pie mr-1" style={{backgroundImage: 'conic-gradient(#808184 1.0%, #E5E5E5 1.5%, #E5E5E5)'}}></div>1.0%</Box>
                  </TableCell>
                </TableRow>
              }
              {(uniqueRows && resultRows) && resultRows
              .slice(this.props.page * this.state.rowsPerPage, this.props.page * this.state.rowsPerPage + this.state.rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.topic_id}>
                    <TableCell align="left">
                      <Thumbnail
                        entityOverrideImage={row.entity_override_image}
                        thumbnail={row.thumbnail}
                        name={row.display_name || row.name}
                        imageSpanClass={this.props.classes.anticipationImageSpan}
                        imageClass={this.props.classes.anticipationImage}
                        noImgTextClass={'aaNoImgText'}
                        noImgClass={'aaNoImg'}
                        divId={`content_preference_${index}`}
                      />
                    </TableCell>
                    <TableCell>{row.display_name || row.name}</TableCell>
                    <TableCell>{this.formatDate(row.premiere_date)}</TableCell>
                    <TableCell>{row.genre && row.genre.length > 2 ? 'Multiple' : row.genre && row.genre.length === 2 ? row.genre.join().replace(',', ', ') : row.genre}</TableCell>
                    { this.renderPieChart(row.premiere_date) &&
                      <>
                        <TableCell>
                          <Box className="flexCenter"><div className="pie mr-1" style={{backgroundImage: `conic-gradient(#808184 ${row.new_to_network}%, #E5E5E5 1.5%, #E5E5E5)`}}></div>{Math.round(row.new_to_network * 1000) / 1000}%</Box>
                        </TableCell>
                        <TableCell align="right">
                          <Box className="flexCenterStart"><div className="pie mr-1" style={{backgroundImage: `conic-gradient(#808184 ${row.network_audience_lift}%, #E5E5E5 1.5%, #E5E5E5)`}}></div>{Math.round(row.network_audience_lift * 1000) / 1000}%</Box>
                        </TableCell>
                      </>
                    }
                    { !this.renderPieChart(row.premiere_date) &&
                      <>
                        <TableCell><span>N/A</span></TableCell>
                        <TableCell><span className='flexCenterStart'>N/A</span></TableCell>
                      </>
                    }
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        { (this.state.showShortcutDataLimitText && this.props.shortcut) &&
          <div className='shortCutBanner'>
            <span>Additional data available via subscription to the Diesel Labs Insights platform</span>
          </div>
        }
        <Table className='tableFooter'>
          <TableBody>
            <TableFooter>
              <TablePagination
                rowsPerPageOptions= {[5, 10, uniqueRows.length]}
                count={uniqueRows.length}
                rowsPerPage={this.state.rowsPerPage}
                page={this.props.page}
                onChangePage={this.handleChangePage}
                labelDisplayedRows={({ from, to, count}) => this.paginationLabel(from, to, count, totalCount)}
                />
            </TableFooter>
          </TableBody>
        </Table>
      </>
    )
  }
}

export default withStyles(styles)(AcquisitionPremiereComponent)
